import { defineStore } from 'pinia';
import type { dynamicObj } from 'src/pages/assets';
import { fields } from 'src/formBuilder/components/GeneralSettings/fields-def';

export const useFormBuilderSettingsStore = defineStore(
  'form_builder_settings_store',
  {
    state: () => ({
      general_settings_loaded: false,
      settings: {} as dynamicObj,
    }),
    getters: {
      isConfirmationBoxDisable(state) {
        let is_disable = false;

        if (
          state.settings.hasOwnProperty(
            'disable_extraction_confirmation_box',
          ) &&
          state.settings.disable_extraction_confirmation_box == true
        ) {
          is_disable = true;
        }
        return is_disable;
      },

      isValidationTimeSpentTimerEnable(state) {
        let is_disable = false;

        if (
          state.settings.hasOwnProperty('validation_time_spent_counter') &&
          state.settings.validation_time_spent_counter == true
        ) {
          is_disable = true;
        }
        return is_disable;
      },
      autoGenerateTabIndex(state) {
        let is_disable = false;

        if (state.settings.auto_generate_tab_index) {
          is_disable = true;
        }
        return is_disable;
      },
    },
    actions: {
      resetStoreOnRouteChange() {
        this.$reset();
      },
      setGeneralSettings(layout_json: dynamicObj) {
        if (!layout_json.hasOwnProperty('general_settings')) {
          this.loadDefaults();
          return;
        }

        this.settings = layout_json.general_settings;
        this.loadDefaults();
      },

      getGeneralSettingsToSave() {
        return {
          general_settings: this.settings,
        };
      },

      loadDefaults() {
        for (const [index, field] of fields.entries()) {
          if (this.settings[field.name]) {
            continue;
          }
          this.settings[field.name] = field.value;
        }
      },
    },
  },
);
